import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BlogPost } from '@/mocks/blogPosts';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard = ({ post }: BlogCardProps) => {
  const { i18n } = useTranslation();
  const isEs = i18n.resolvedLanguage === 'es';

  return (
    <Link to={`/blog/${post.slug}`} className="group block cursor-pointer">
      <div className="relative overflow-hidden rounded-2xl h-52 mb-4">
        <img
          src={post.img}
          alt={isEs ? post.titleEs : post.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-white/90 text-black text-xs font-semibold px-3 py-1 rounded-full">
            {isEs ? post.categoryEs : post.category}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-3 mb-2">
        <span className="text-gray-400 text-xs">{post.date}</span>
        <span className="text-gray-300 text-xs">·</span>
        <span className="text-gray-400 text-xs">{post.readTime}</span>
      </div>
      <h3 className="text-black font-semibold text-base leading-snug mb-2 group-hover:text-gray-700 transition-colors duration-300 line-clamp-2">
        {isEs ? post.titleEs : post.title}
      </h3>
      <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">
        {isEs ? post.excerptEs : post.excerpt}
      </p>
      <div className="flex items-center gap-2 mt-3 text-black text-sm font-medium group-hover:gap-3 transition-all duration-300">
        {isEs ? 'Leer Más' : 'Read More'} <i className="ri-arrow-right-line text-sm"></i>
      </div>
    </Link>
  );
};

export default BlogCard;
